import React from 'react';
import seagullSpeechBubble from '../../public/static/images/seagullSpeechBubble.png';
import { FAQ_ITEMS } from '../../constants';
import ProgressDots from '../ProgressDots';
import { useMediaQuery } from '../../hooks';

import styles from './index.module.scss';

const FAQ = () => {
  const { isLargeScreen } = useMediaQuery();

  return (
    <section id="faq" className={styles.section}>
      <header className={styles.header}>
        <h2 className={styles.title}>
          <img className={styles.icon} src={seagullSpeechBubble} alt="" />
          <div className={styles.titleText}>
            <span>BF Island: </span>
            <span>The Unserious FAQ</span>
          </div>
        </h2>
      </header>

      <div className={styles.faqList}>
        {FAQ_ITEMS.map((item) => (
          <article className={styles.item} key={item.title}>
            <h3 className={styles.question}>{item.title}</h3>
            <p className={styles.answer}>{item.description}</p>
          </article>
        ))}
      </div>
      {!isLargeScreen && <ProgressDots count={3} activeIndex={0} />}
    </section>
  );
};

export default FAQ;
